/**
 * @generated SignedSource<<f73b7d6cda4ac034cb70732c02193503>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "provisionerId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountEmail",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "provisionerid",
        "variableName": "provisionerId"
      }
    ],
    "concreteType": "CustList",
    "kind": "LinkedField",
    "name": "listmappedaccounts",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CustListCust",
        "kind": "LinkedField",
        "name": "customers",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountDelegatedAuth",
        "kind": "LinkedField",
        "name": "integrations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adaId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationAccountMap",
            "kind": "LinkedField",
            "name": "maps",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entityId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerFetchCountAndMapsQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomerFetchCountAndMapsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "767dea4caa2b5e0a5d0d85e5b4fd3164",
    "id": null,
    "metadata": {},
    "name": "CustomerFetchCountAndMapsQuery",
    "operationKind": "query",
    "text": "query CustomerFetchCountAndMapsQuery(\n  $provisionerId: UUID!\n) {\n  listmappedaccounts(provisionerid: $provisionerId) {\n    customerCount\n    customers {\n      accountId\n      accountName\n      accountEmail\n    }\n    integrations {\n      adaId\n      appName\n      maps {\n        accountId\n        accountName\n        accountEmail\n        entity\n        entityId\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "14f6dd9d65e97deef6b4eb7f528db2c7";

module.exports = node;
